import { NewsletterSingle } from 'modules/newsletters/single'
import { NewslettersEditLoco } from 'modules/newsletters/single/constants/newsletters-loco'
import { useGetNewsletterView } from 'modules/newsletters/single/hooks/use-get-newsletter-view'
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface'
import { NewsletterSplitTest } from 'modules/newsletters/split-test'
import { NextPage } from 'next'
import { useRouter } from 'next/router'
import { Loader } from 'shared/components/loader'
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props'

const NewsletterEdit: NextPage = () => {
  const router = useRouter()
  const newsletterId = Number(router.query.newsletterId) as NewsletterId

  const { newsletterData } = useGetNewsletterView({
    newsletterId,
  })

  return newsletterData ? (
    newsletterData.mailingSplitTest ? (
      <NewsletterSplitTest newsletterWithSplitTest={newsletterData} newsletterId={newsletterId} />
    ) : (
      <NewsletterSingle newsletterData={newsletterData} newsletterId={newsletterId} />
    )
  ) : (
    <div className={'flex h-full items-center justify-center'}>
      <Loader type="dark" />
    </div>
  )
}

export const getServerSideProps = getBaseServerSideProps(
  NewslettersEditLoco,
  'header.top_menu.newsletters',
)

export default NewsletterEdit
